import { Responsibility } from "./Responsibility";
import nameof from "ts-nameof.macro";
import { ObjectField, ObjectList } from "react3l-decorators";
import { Site } from "models/Site";
import { Status } from "models/Status";
import { ResponsibilityRoleMapping } from "models/ResponsibilityRoleMapping";

ObjectField(Site)(
  Responsibility.prototype,
  nameof(Responsibility.prototype.site)
);
ObjectField(Status)(
  Responsibility.prototype,
  nameof(Responsibility.prototype.status)
);
ObjectList(ResponsibilityRoleMapping)(
  Responsibility.prototype,
  nameof(Responsibility.prototype.responsibilityRoleMappings)
);

export * from "./Responsibility";
export * from "./ResponsibilityFilter";
